module.exports = __webpack_public_path__ + "static/media/maca_inteira.33d67508.png";